import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import Home from "./pages/Home";
import ReactivationType from "./pages/Reactivation";
import ModificationType from "./pages/ModificationType";
// import MobileEmailModification from "./pages/MobileEmailModification";
// import MobileModification from "./pages/MobileModification";
// import MobileEmailOtpVerify from "./pages/MobileEmailOtpVerify";
// import MobileOtpVerify from "./pages/MobileOtpVerify";
// import EmailOtpVerify from "./pages/EmailOtpVerify";
// import Reason from "./pages/Reason";
// import Review from "./pages/Review";
// import ESignature from "./pages/ESignature";
import MobileModifications from "./pages/MobileModifications";
import EmailModifications from "./pages/EmailModifications";
import MobileEmailModifications from "./pages/MobileEmailModifications";
import AddressModification from "./pages/AddressModification";
import NomineeModification from "./pages/NomineeModification";
import BankModification from "./pages/BankModification";
import IncomeModifications from "./pages/IncomeModifications";
import SegmentModifications from "./pages/SegmentModifications";
import MultipleRequestTypes from "./pages/MultipleRequestTypes";
import {
  setThemeColors,
  setGradientColors,
  setNomineeProofvalidate,
  setReactivationProof,
  setAccountClosureScreen,
} from "../../redux/actions";
import useIdle from "hooks/useIdleTimeout";

// themes

// 101
import LeftBarDesign101 from "../../design1/LeftBarDesign";
// 102
import LeftBarDesign102 from "../../design2/LeftBarDesign";
// 103
import LeftBarDesign103 from "../../design3/LeftBarDesign";
// 104
import LeftBarDesign104 from "../../design4/LeftBarDesign";
// 105
import LeftBarDesign105 from "../../design5/LeftBarDesign";
// 106
import LeftBarDesign106 from "../../design6/LeftBarDesign";
// 107
import LeftBarDesign107 from "../../design7/LeftBarDesign";
// 108
import LeftBarDesign108 from "../../design8/LeftBarDesign";
// 109
import LeftBarDesign109 from "../../design9/LeftBarDesign";
// 110
import LeftBarDesign110 from "../../design10/LeftBarDesign";

function LeftBarDesign({ theme, ...props }) {
  switch (theme) {
    case "101":
      return <LeftBarDesign101 {...props} />;
    case "102":
      return <LeftBarDesign102 {...props} />;
    case "103":
      return <LeftBarDesign103 {...props} />;
    case "104":
      return <LeftBarDesign104 {...props} />;
    case "105":
      return <LeftBarDesign105 {...props} />;
    case "106":
      return <LeftBarDesign106 {...props} />;
    case "107":
      return <LeftBarDesign107 {...props} />;
    case "108":
      return <LeftBarDesign108 {...props} />;
    case "109":
      return <LeftBarDesign109 {...props} />;
    case "110":
      return <LeftBarDesign110 {...props} />;
    default:
      return <LeftBarDesign101 {...props} />;
  }
}

const ModifyKyc = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { brokerID } = useParams();
  const [stageScreen, setStageScreen] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const { themeTemplate } = useSelector((state) => state.theme);

  const handleIdle = () => {
    window.location.href = `/m/${brokerID}`;
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  const { idleTimer } = useIdle({ onIdle: handleIdle, idleTime: 900 }); // 15min

  const handleStay = () => {
    setOpenModal(false);
    idleTimer.reset();
  };

  useEffect(() => {
    const theme = window.sessionStorage.getItem("theme_color_pallate");
    const gradient = window.sessionStorage.getItem("gradientColor");
    const hasNomineeProofValidate = window.sessionStorage.getItem(
      "hasNomineeProofValidate"
    );
    const hasReactivationProof = window.sessionStorage.getItem(
      "hasReactivationProof"
    );
    const accountClosureScreen = window.sessionStorage.getItem(
      "accountClosureScreen"
    );
    if (theme && gradient) {
      dispatch(setThemeColors(JSON.parse(theme)));
      dispatch(setGradientColors(JSON.parse(gradient)));
    }
    hasNomineeProofValidate &&
      dispatch(setNomineeProofvalidate(JSON.parse(hasNomineeProofValidate)));
    hasReactivationProof &&
      dispatch(setReactivationProof(JSON.parse(hasReactivationProof)));
    accountClosureScreen &&
      dispatch(setAccountClosureScreen(JSON.parse(accountClosureScreen)));
  }, [dispatch]);

  useEffect(() => {
    const doc_name = window.sessionStorage.getItem("doc_name");
    if (!doc_name) {
      return;
    }
    setStageScreen("ReactivationType");
  }, []);

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (!user) {
      return history.push(`/m/${brokerID}`);
    }
  }, [history, brokerID]);

  useEffect(() => {
    const isDigilocker = localStorage.getItem("isDigilocker");
    if (isDigilocker) {
      setStageScreen("Address Modification");
    }
  }, []);

  const InitScreen = () => {
    let html = null;
    if (stageScreen === "Mobile and Email Modification") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <MobileEmailModifications
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "Mobile Modification") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <MobileModifications
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "Email Modification") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <EmailModifications
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "Address Modification") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <AddressModification
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "Bank Modification") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <BankModification
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "Nominee Modification") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <NomineeModification
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "Income Proof Modification") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <IncomeModifications
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "Segment Modification") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <SegmentModifications
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "MultipleRequestTypes") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={
            <MultipleRequestTypes
              stageScreen={stageScreen}
              setStageScreen={setStageScreen}
            />
          }
        />
      );
    } else if (stageScreen === "ModificationType") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={<ModificationType setStageScreen={setStageScreen} />}
        />
      );
    } else if (stageScreen === "ReactivationType") {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={<ReactivationType setStageScreen={setStageScreen} />}
        />
      );
    } else {
      html = (
        <LeftBarDesign
          theme={themeTemplate}
          innerDesign={<Home setStageScreen={setStageScreen} />}
        />
      );
    }
    return html;
  };

  return (
    <>
      <InitScreen />
      <Modal
        show={openModal}
        onHide={handleStay}
      >
        <Modal.Header>
          <Modal.Title>Your session is expire</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Your session is expire. You'll be automatically signed out.</p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModifyKyc;
